import React from "react";

const Attr = () => {
  return (
    <div className="attribution w-full absolute left-1/2 bottom-2 -translate-x-1/2">
      Challenge by{" "}
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">
        Frontend Mentor
      </a>
      . Coded by{" "}
      <a href="https://github.com/Ahmed102952" target="_blank" rel="noreferrer">
        Angel aka (A.M)
      </a>
      .
    </div>
  );
};

export default Attr;
